import { Component, Input } from '@angular/core';
import { CatchHistory } from 'src/app/pages/area/area.model';
import { BaseAreaMonitorAccordionComponent } from '../base-accordion.component';
import { AccordionService } from 'src/app/services/accordion.service';

@Component({
  selector: 'app-area-monitor-catch-history',
  templateUrl: './area-monitor-catch-history.component.html',
  styleUrls: ['./area-monitor-catch-history.component.scss'],
})
export class AreaMonitorCatchHistoryComponent extends BaseAreaMonitorAccordionComponent {
  @Input() catchHistory: CatchHistory[];

  constructor(accordionService: AccordionService) {
    super(accordionService);
  }
}
